import { faEdit, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Link } from 'react-router-dom'
import Loader from '../../Layout/Loader'
import mainAxios from '../../../services/mainAxios'
import { useTranslation } from "react-i18next";

import PrimeTable from '../../PrimeTable/PrimeTable';
import ExportCsvPrime from '../../global/ExportCsvPrime';
import { Dialog } from "primereact/dialog";
import EditCategories from './EditCategories';

const moment = require("moment")

const ItemsCategory = () => {

    const [categories, setCategories] = React.useState(null)
    const { t, i18n } = useTranslation('translations');
    const company = localStorage.getItem('selectedCompany')
    const [visibleCategory, setVisibleCategory] = React.useState({ open: false, id: null });
    const [reloadCategory, setReloadCategory] = React.useState(false)
    const [loadingCategories, setLoadingCategories] = React.useState(false)
    const [tableRows, setTableRows] = React.useState({
        totalRows: 0,
        rowsPerPage: 10,
        currentPage: 1,
    });
    const [filters, setFilters] = React.useState({
        params:{}
      });

      const defaultFilters = {
        active: null
      }

    const getFilteredResults = ({ updatedFilters, rowsPerPage = 10, currentPage = 1, exportCsv = false, sortCriteria, searchQuery } = {}) => {
        if (!exportCsv) setLoadingCategories(true)
        mainAxios.post('apiEndpoint/search', {
            object: "GetCategories",
            params: {
                id: company.id,
            },
            pagination: exportCsv ? null : {
                pageSize: rowsPerPage,
                pageNumber: currentPage,
            },
            params:updatedFilters?.params,
            sortCriteria,
            value: null,
            type: "basic"
        }).then(res => {
            if (!exportCsv) setLoadingCategories(false)
            if (res) {
                setCategories(res.data.content)
                setTableRows((tableRows) => ({
                    ...tableRows,
                    totalRows: res?.data?.totalSize,
                }));
                return true
            }
            return false
        })
            .catch(err => {
                if (!exportCsv) setLoadingCategories(false)
                return false
            })
    }

    React.useEffect(() => {
        getFilteredResults()
    }, [company, reloadCategory])

    const onUpdateCategory = () => {
        setReloadCategory(rlCategory => !rlCategory)
        setVisibleCategory({ open: false, id: null })
    }

    const getItemCategory = () => {
        return mainAxios.post('apiEndpoint/search', {
            object: "GetCategories",
            value: null,
            type: 'basic',
            params: {
                id: company.id,
            },

        }).then(res => {
            if (res) {
                setCategories(res.data.content)
                return true
            }
            return false
        })
    }

    const columns = [
        {
            header: `${t('item.name')}`,
            field: 'name',
            sortable: true,
            filter:true,
            style: { minWidth: '30px', maxWidth: "30px", height: "45px" },
            formatedExportValue: true,
            mobile: { priority: 1, isTitle: true, group: "identity" },

        },
        {
            header: `${t('item.code')}`,
            field: 'code',
            sortable: true,
            filter:true,
            style:{ minWidth: '30px', maxWidth:"30px" },
            formatedExportValue: true,
            mobile: { priority: 1, group: "identity" },

        },
        {
            header: `${t("itemsCategory.categoryType")}`,
            field: 'type',
            sortable: true,
            formatedExportValue: true,
            style:{ minWidth: '30px', maxWidth:"30px" },
            mobile: { priority: 1, group: "details" },
            format: (value) => {
                if (value.type == 1) return "Normal"
                return value.type
            },
            body: (value) => {
                if (value.type == 1) return "Normal"
                return value.type
            }
        },
        {
            header: `${t('itemsCategory.active')}`,
            field: 'isActive',
            sortable: true,
            filter:true,
            dataType: "boolean",
            filterType:"TRISTATECHECKBOX",
            formatedExportValue: true,
            format: (value) => {
               return value.active ? 'Yes' : 'No'
            },
            align:"center",
            style:{ minWidth: '30px', maxWidth:"30px" },
            body: (value) => value.active ? 'Yes' : 'No',
            mobile: { priority: 1, isBadge: true, group: "status" },
        },
        {
            header: t(['home.actions']),
            field: "actions",
            mobile: { priority: "action", group: "actions" },
            body: categories => (
                <>
                    <Link
                        onClick={() => setVisibleCategory({ open: true, id: categories.id })}
                        className="table-action-link">
                        <FontAwesomeIcon icon={faEdit} />
                        {t('company.edit')}
                    </Link>
                </>
            )
        }
    ];


    const headerButtonsRight = (
        <div className="prime-table-toolbar__add-btn" onClick={() => setVisibleCategory({ open: true, id: null })}>
            <FontAwesomeIcon icon={faPlus} />
            {t("itemsCategory.addCategory")}
        </div>
    );

    const headerIcons = (
        <ExportCsvPrime
            iconOnly
            tooltip="Export CSV"
            data={categories}
            columns={columns}
            onClick={() => getItemCategory({ exportCsv: true })}
            excludedColumns={["expansionCol", "actions"]}
        />
    );

    return (
        categories ?
            <>
                <Dialog
                    header={visibleCategory?.id ? t("itemsCategory.editCategory") : t("itemsCategory.addCategory")}
                    visible={visibleCategory?.open}
                    onHide={() => setVisibleCategory({ open: false, id: null })}
                    style={{ width: "30vw" }}
                    breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                >
                    {visibleCategory?.open && <EditCategories onUpdateCategory={onUpdateCategory} id={visibleCategory?.id} />}
                </Dialog>
                <PrimeTable
                    columns={columns}
                    loading={loadingCategories}
                    value={[...categories]}
                    filters={[filters, setFilters]}
                    tableRows={[tableRows, setTableRows]}
                    reorderableColumns={true}
                    showFilters={true}
                    defaultFilters={defaultFilters}
                    headerButtonsRight={headerButtonsRight}
                    headerIcons={headerIcons}
                    responsiveLayout="scroll"
                    filterDisplay={'row'}
                    showSelectColumns={false}
                    onRemoteDataChange={(remoteData) => {
                        const updatedFilters = remoteData.filters
                        const updatedTableData = remoteData.tableRows ?? tableRows
                        let { currentPage, rowsPerPage, sortCriteria } = updatedTableData
                        sortCriteria = sortCriteria ? [sortCriteria] : null
                        getFilteredResults({ updatedFilters, rowsPerPage, currentPage, sortCriteria, searchQuery: remoteData?.searchQuery })
                    }}
                />
            </>
            :
            <Loader />
    )
}

export default ItemsCategory